module.exports = new __parcel__URL__("WevrTerms&Conditions.32cb3cf7.pdf").toString();